export type SoilImprover = 'low' | 'high';

//! this is a fake type, replace it with the real one;
//! if a new one is not provide by the march 2026, remove it and all the references to it
export type AdditionalParameters = 'bar' | 'foo';

export type SoilImproverAdditionalParameter = {
  key: 'soil_improver';
  values: SoilImprover[];
};

export type ExtraAdditionalParameter = {
  key: 'additional_params';
  values: AdditionalParameters[];
};

export type PracticeAdditionalParameter =
  | SoilImproverAdditionalParameter
  | ExtraAdditionalParameter;

export type SelectedParameters = Record<
  PracticeAdditionalParameter['key'],
  PracticeAdditionalParameter
>;

export type RequirementManualVerification = {
  required: boolean;
  key: string;
  optionsAlternative?: RequirementManualVerification[];
  translationKey: string;
};

export const PracticeType = {
  MANUAL: 'MANUAL',
  SATELLITE: 'SATELLITE',
};

export class RegenerativePractice {
  additionalParameters: PracticeAdditionalParameter[] = [];
  companyId: number = null;
  companyIdCreated: number = null;
  dateCreated: number = null;
  id: string = null;
  imgUrl: string = null;
  isRequired?: boolean = false; // optional variable used by the FE to render the currect UI
  lastModify: string = null;
  manualVerification: boolean = false;
  name: string = null;
  requirementsManualVerification: RequirementManualVerification[] = [];
  satelliteVerification: boolean = false;
  selected?: boolean = false; // optional variable used by the FE to render the currect UI
  type: string = '';
}
